import { Box } from "@chakra-ui/react";
import CurrentImagePreview from "./currentImagePreview";

const CreateImageView = () => {
  return (
    <Box
      sx={{
        width: "full",
        height: "full",
        border: "2px dashed #27314D"
      }}
    >
      <CurrentImagePreview />
    </Box>
  );
};

export default CreateImageView;
